import { useEffect } from "react";

/**
 * Global URL trigger: appending ?reset or ?refresh to ANY page forces
 * a hard reload of that page (fresh network fetch). The trigger param
 * is stripped from the URL so it only fires once.
 *
 * Other query params and the hash are preserved.
 */
export const ResetHandler = () => {
  useEffect(() => {
    if (typeof window === "undefined") return;

    const url = new URL(window.location.href);
    const hasReset = url.searchParams.has("reset");
    const hasRefresh = url.searchParams.has("refresh");
    if (!hasReset && !hasRefresh) return;

    url.searchParams.delete("reset");
    url.searchParams.delete("refresh");

    const cleaned =
      url.pathname +
      (url.searchParams.toString() ? `?${url.searchParams.toString()}` : "") +
      url.hash;

    window.location.replace(cleaned);
  }, []);

  return null;
};
